import { render, staticRenderFns } from "./functionalities-register.page.vue?vue&type=template&id=288e56cc"
import script from "./functionalities-register.page.vue?vue&type=script&lang=ts"
export * from "./functionalities-register.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports